/**
 * Returns what environment we are running in.
 */
export default function getTrackingEnvironment() {
  return new URL(window.location.href).searchParams.get('tracking-env') || 'prod';
}

/**
 * Returns true if the environment is dev.
 */
export const isTrackingDev = getTrackingEnvironment() === 'dev';
